import findAllButById from 'helpers/findAllButById'
import findById from 'helpers/findById'

export default function addMapComponentReferences(state, action) {
  const { componentType, id, references } = action
  const updatedComponent = Object.assign({}, findById({ state: state[componentType] || state.map[componentType], id: id }), { ...references })

  if (componentType === 'cameras') {
    return Object.assign({}, state, {
      cameras: [
        ...findAllButById({ state: state.cameras, id })
          .concat(updatedComponent)
      ]
    })
  } else {
    return Object.assign({}, state, {
      map: {
        ...state.map,
        [componentType]: [
          ...findAllButById({ state: state.map[componentType], id })
            .concat(updatedComponent)
        ]
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/reducers/addMapComponentReferences.js